import React, { Component, useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/lib/cart";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Struggling from "@/pages/Struggling";
import Routine from "@/pages/Routine";
import Results from "@/pages/Results";
import Faqs from "@/pages/Faqs";
import Contact from "@/pages/Contact";
import Shop from "@/pages/Shop";
import Checkout from "@/pages/Checkout";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-[#E8F3EB] text-[#1A3626] grid place-items-center p-8">
          <div className="max-w-md text-center">
            <p className="font-display text-4xl text-[#1B4332]">Something went sideways.</p>
            <p className="mt-3 text-[#4A6B56]">Refresh the page to get back to your ritual.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        <CartProvider>
          <div className="min-h-screen bg-[#E8F3EB] text-[#1A3626] antialiased">
            <div className="grain-overlay" aria-hidden="true" />
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/struggling" element={<Struggling />} />
                <Route path="/routine" element={<Routine />} />
                <Route path="/results" element={<Results />} />
                <Route path="/faqs" element={<Faqs />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="*" element={<Home />} />
              </Routes>
            </main>
            <Footer />
            <CartDrawer />
            <Toaster position="top-center" toastOptions={{ style: { background: "#1B4332", color: "#E8F3EB" } }} />
          </div>
        </CartProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
